var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1636_748)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1636_748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6872 4.45426L8.15597 1.79704C8.05506 1.76142 7.94497 1.76142 7.84406 1.79704L0.312813 4.45426C0.125563 4.52032 0.000250375 4.6972 3.74595e-07 4.89576C-0.000249625 5.09432 0.124657 5.27148 0.31175 5.33798L7.843 8.01539C7.89378 8.03345 7.94691 8.04248 8 8.04248C8.05313 8.04248 8.10622 8.03345 8.157 8.01539L15.6882 5.33798C15.8753 5.27148 16.0002 5.09432 16 4.89576C15.9997 4.6972 15.8744 4.52032 15.6872 4.45426Z",
    fill: "#55BAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 10.7111V6.62238L13.9375 6.95566V10.7111C13.6551 10.8737 13.4648 11.1782 13.4648 11.5274C13.4648 11.8766 13.6551 12.1812 13.9375 12.3437V14.6473C13.9375 14.9062 14.1474 15.1161 14.4062 15.1161C14.6651 15.1161 14.875 14.9062 14.875 14.6473V12.3437C15.1574 12.1812 15.3477 11.8766 15.3477 11.5274C15.3477 11.1782 15.1574 10.8737 14.875 10.7111Z",
    fill: "#55BAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00175 8.97996C7.84084 8.97996 7.68238 8.95262 7.53072 8.89871L3.29688 7.39355V9.45631C3.29688 9.96096 3.82334 10.3877 4.86166 10.7247C5.76669 11.0185 6.88188 11.1803 8.00175 11.1803C9.12162 11.1803 10.2368 11.0185 11.1418 10.7247C12.1802 10.3877 12.7066 9.96096 12.7066 9.45631V7.39355L8.47281 8.89871C8.32113 8.95262 8.16266 8.97996 8.00175 8.97996Z",
    fill: "#55BAF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1636_748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1636_748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.443176)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education_icon.271314fa230fb30101a412779971b456.svg";
export { ForwardRef as ReactComponent };